import { Link } from '@tanstack/react-router';
import promotionEventBannerArt from '@/assets/home/promotion-event-banner.png';
import { cn } from '@/lib/cn';

export interface PromotionEventBannerProps {
  className?: string;
}

/**
 * Figma PromotionEventBanner — static mid-page promo between Biggest Wins and Latest Wins.
 */
export function PromotionEventBanner({ className }: PromotionEventBannerProps) {
  return (
    <Link
      to="/sports"
      className={cn(
        'relative block h-[140px] w-full overflow-hidden rounded-md bg-bg-canvas',
        className,
      )}
      aria-label="FIFA 2026 — Bets are Open!"
    >
      <img
        src={promotionEventBannerArt}
        alt=""
        className="absolute inset-0 size-full object-cover"
        draggable={false}
      />
    </Link>
  );
}
